import React from 'react';
import { Link } from 'react-router-dom';

import { EmptyStateOverlay } from '@trqk/components';
import { locale } from '@trqk/utils';

import { FULL_PATHS, HASHES } from '../../constants';

import emptyStatementImg from '../../assets/svg/statements_empty.svg';

export const ShouldUploadStatements = (): JSX.Element => (
    <EmptyStateOverlay>
        <div className="px-16 pt-12">
            <img
                src={emptyStatementImg}
                width={35}
                alt="Empty statement icon"
            />
            <div className="text-xs font-semibold tracking-widest mt-6 mb-4">
                {locale.enUS.STATEMENTS.SHOULD_UPLOAD_STATEMENTS.ADD_A_STATEMENT_TO_GET_STARTED.toUpperCase()}
            </div>
            <div className="text-xl font-semibold">
                {
                    locale.enUS.STATEMENTS.SHOULD_UPLOAD_STATEMENTS
                        .UPLOAD_STATEMENTS
                }
                &nbsp;
                <Link
                    className="respond-to-mouse font-bold text-primary-500 underline"
                    to={({ search }) => ({
                        hash: HASHES.MANAGE_STATEMENTS.UPLOADS,
                        pathname: FULL_PATHS.MANAGE_STATEMENTS_CHARTS,
                        search,
                    })}
                >
                    {locale.enUS.STATEMENTS.SHOULD_UPLOAD_STATEMENTS.HERE}
                </Link>
                .
            </div>
        </div>
    </EmptyStateOverlay>
);
